var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.AssociationDia.visible,
        title: "选择模版",
        width: "800px",
        top: "7vh",
        "destroy-on-close": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.AssociationDia, "visible", $event)
        },
      },
    },
    [
      _vm.AssociationDia.visible
        ? _c("regional-agent", {
            staticClass: "mb20",
            attrs: { isShowAction: false },
            on: { getTemplateId: _vm.getTemplateId },
          })
        : _vm._e(),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(" 取消 "),
          ]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "debounceClick",
                  rawName: "v-debounceClick",
                  value: _vm.handleConfirm,
                  expression: "handleConfirm",
                },
              ],
              attrs: { type: "primary" },
            },
            [_vm._v(" 确定 ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }